import { Autocomplete, Grid, Select } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { useIsFirstRender } from '@mantine/hooks'
import { useEffect } from 'react'
import { PillowType } from 'types/products'
import { optionsFilter } from './utils'

type PillowSizeValues = {
  pillowType: PillowType
  size: string
}

type Props<Values extends PillowSizeValues> = {
  form: UseFormReturnType<Values>
  disabled?: boolean
}

export default function PillowSizeInput<Values extends PillowSizeValues>({ form, disabled }: Props<Values>) {
  const isFirstRender = useIsFirstRender()

  useEffect(() => {
    if (form.values.pillowType === undefined) return
    if (form.values.size === undefined) return
    const firstSize = form.values.pillowType === PillowType.FABRIC ? fabricSizes[0] : premadeSizes[0]
    form.setFieldValue('size', isFirstRender ? (form.values.size as never) : (firstSize as never))
  }, [form.values.pillowType])

  return (
    <Grid>
      <Grid.Col span={6}>
        <Select
          label="Rodzaj poszewki"
          description="Uszyta gotowa poszewka lub materiał"
          placeholder="Wybierz rodzaj"
          allowDeselect={false}
          data={[
            { label: 'Gotowa', value: PillowType.PREMADE },
            { label: 'Materiał', value: PillowType.FABRIC },
          ]}
          withAsterisk
          disabled={disabled}
          {...form.getInputProps('pillowType')}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <Autocomplete
          label="Wymiar"
          disabled={disabled || form.values.pillowType === undefined}
          description="Wymiary w cm. Dostępne wymiary zależą od rodzaju poszewki"
          placeholder="Wybierz wymiar"
          data={form.values.pillowType === PillowType.FABRIC ? fabricSizes : premadeSizes}
          withAsterisk
          filter={optionsFilter}
          {...form.getInputProps('size')}
          onChange={(value) => {
            // remove whitespaces
            form.setFieldValue('size', value.replaceAll(' ', '') as never)
          }}
        />
      </Grid.Col>
    </Grid>
  )
}

const premadeSizes = ['40x40', '45x45', '50x50', '40x60']
const fabricSizes = ['43x83', '48x93', '53x103', '43x123']
